// Sign-up proof of work (the Worker's src/pow.ts checks it): find a nonce so that
// SHA-256("<challenge>:<nonce>") starts with `difficulty` zero bits. About a second or two in a
// browser at the starting difficulty. Hashing runs in batches so the screen stays responsive.
const enc = new TextEncoder();
const BATCH = 2048;

export function leadingZeroBits(bytes: Uint8Array): number {
  let bits = 0;
  for (const b of bytes) {
    if (b === 0) bits += 8;
    else return bits + Math.clz32(b) - 24;
  }
  return bits;
}

export async function solvePow(challenge: string, difficulty: number, isCancelled: () => boolean = () => false): Promise<string> {
  for (let start = 0; ; start += BATCH) {
    if (isCancelled()) throw new Error('cancelled');
    const digests = await Promise.all(Array.from({ length: BATCH }, (_, i) => crypto.subtle.digest('SHA-256', enc.encode(`${challenge}:${start + i}`))));
    for (let i = 0; i < BATCH; i++) if (leadingZeroBits(new Uint8Array(digests[i])) >= difficulty) return String(start + i);
  }
}
